import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#F6F7F8"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.8 11.152C21.176 11.152 24.632 14.56 24.632 19.576C24.632 24.568 21.176 28 15.8 28H9.488V11.152H15.8ZM13.592 24.448H15.536C18.632 24.448 20.456 22.672 20.456 19.576C20.456 16.48 18.632 14.656 15.536 14.656H13.592V24.448Z",
      fill: "#151F6D"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "var(--secondary)"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "var(--primary)"
    }, null, -1)
  ])))
}
export default { render: render }